<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.items_trending") }}
    </div>
    <v-row class="mt-2 ml-3">
      <v-card-text class="" style="font-size: 1rem !important">
        <span style="color: red;">*</span>{{ $vuetify.lang.t("$vuetify.ai_response.prerequisite_txt") }}
      </v-card-text>
      <v-card-text class="text-caption text--secondary ml-3" style="font-size: 0.85rem !important">
        1. {{ $vuetify.lang.t("$vuetify.ai_response.items_trending_txt1") }}
      </v-card-text>
    </v-row>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-select
            v-model="interval"
            :items="INTERVAL"
            :label='$vuetify.lang.t("$vuetify.ai_response.select_interval")'
            outlined
            required
            dense
            :rules="[
              required($vuetify.lang.t('$vuetify.ai_response.interval')),
            ]"
          ></v-select>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="number"
            v-model="top_n_item"
            :label='$vuetify.lang.t("$vuetify.ai_response.top_ranked_items")'
            dense
            outlined
            :rules="topNItemsRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-btn
          class="float-right ml-2"
          color="primary"
          @click="getRecommendedItems"
          dark
        >
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
        <v-card-title>
        </v-card-title>
      </v-row>
    </v-form>

    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading">
        <Loader class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
              style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.items_trending") }}
          </div>
        </v-container>

        <v-container>
          <v-row v-if="recommendedItems && recommendedItems.length > 0">
            <v-col
              v-for="product in recommendedItems"
              :key="product[mapper.item_id]"
              cols="12"
              md="3"
            >
              <v-card
                class="product-card"
                @click="copyItemToClipBoard(product)"
                outlined
              >
                <v-img :src="product[mapper.image_url]" height="100px">
                  <template #placeholder>
                    <div
                      class="d-flex align-center justify-center grey--text text-caption"
                      style="height: 100%"
                    >
                      {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                    </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
          </v-col>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">
              {{ $vuetify.lang.t("$vuetify.ai_response.close") }}
            </v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { FETCH_TRENDING_ITEMS, ADD_ALERT} from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      interval: "",
      top_n_item: 1,
      INTERVAL : [
        "weekly",
        "bi-weekly",
        "monthly",
        "quarterly",
        "yearly"
      ],
      topNItemsRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ]
    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  methods: {
    ...mapActions("ai_response", [FETCH_TRENDING_ITEMS]),
    ...mapActions("alert", [ADD_ALERT]),
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },


    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
        `alert/${ADD_ALERT}`, {
          message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
          color: "success",
        }, { root: true }
      );
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      this.openResponseModal = true
      this.responseLoading = true
      this.FETCH_TRENDING_ITEMS({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        interval: this.interval,
        top_n_item: this.top_n_item
      }).then(
        (response) => {
          this.responseLoading = false
          this.recommendedItems = response.data.detail.response
        },
        (error) => {
          this.openResponseModal = false
          if(error.status === 422){
            this.$store.dispatch(
              `alert/${ADD_ALERT}`, {
                message: JSON.stringify(error?.response?.data?.detail),
                color: "error",
              }, { root: true }
            );
          } else {
            this.$store.dispatch(
              `alert/${ADD_ALERT}`, {
                message: error?.response?.data?.detail?.response,
                color: "error",
              }, { root: true }
            );
          }
          console.error("error", error)
        }
      );
    },
  }
};
</script>

<style scoped>
.product-card {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.card-content {
  padding: 4px;
}

.card-content .v-card-title {
  margin-bottom: 0;
  font-size: 16px;
}

.card-content .v-card-subtitle {
  margin-bottom: 8px;
}
</style>
